import amd from './amd.js';
import cjs from './cjs.js';
import es from './es.js';
import iife from './iife.js';
import umd from './umd.js';

export default { amd, cjs, es, iife, umd };
